<template>
	<h3>Servicer Mailing Information</h3>

	<Form class="form-container">
		<div v-for="field in formFields" :key="field.name" :class="['form-input', field.width]">
			<label :for="field.name">{{ field.label }}</label>
			<Field :id="field.name" :name="field.name" :type="field.type" v-model="field.value" disabled="true" />
		</div>
	</Form>
</template>

<script setup lang="ts">
	import { ref } from 'vue';
	import { Form, Field } from 'vee-validate';
	import { SubServicerAddress } from '@/models/loans';

	interface FormField {
		name: string;
		label: string;
		type: string;
		value: any;
		width: string;
	}

	const props = defineProps<{
		subServicerName: string | null;
		address: SubServicerAddress | null;
	}>();

	const formFields = ref<FormField[]>([
		{
			name: 'subServicerName',
			label: 'Send Payment To',
			type: 'string',
			value: props.subServicerName,
			width: 'col-4'
		},
		{
			name: 'attentionTo',
			label: 'Attention To',
			type: 'string',
			value: props.address?.attentionTo?.name,
			width: 'col-4'
		},
		{
			name: 'address1',
			label: 'Address 1',
			type: 'string',
			value: props.address?.address1,
			width: 'col-6'
		},
		{
			name: 'address2',
			label: 'Address 2',
			type: 'string',
			value: props.address?.address2,
			width: 'col-6'
		},
		{
			name: 'city',
			label: 'City',
			type: 'string',
			value: props.address?.city,
			width: 'col-4'
		},
		{
			name: 'state',
			label: 'State',
			type: 'string',
			value: props.address?.state,
			width: 'col-2'
		},
		{
			name: 'zipCode',
			label: 'Zip Code',
			type: 'string',
			value: props.address?.zipCode,
			width: 'col-3'
		}
	]);
</script>

<style scoped src="@/assets/css/loans/form.css"></style>

<style scoped>
	h3 {
		margin-top: 20px;
		margin-bottom: 15px;
	}
</style>
